import { useMemo } from "react"
import { useQuery } from "urql"

import {
  GetProductInventoryAdjustmentsDocument,
  InventoryAdjustmentStatus,
  InventoryAdjustmentType,
} from "@/graphql/codegen/graphql"

const TERMINAL_STATUSES = new Set([InventoryAdjustmentStatus.Completed, InventoryAdjustmentStatus.Failed])

interface UseInventoryAdjustmentSyncStatusReturn {
  isSyncing: boolean
  isFetching: boolean
}

export const useInventoryAdjustmentSyncStatus = (productId: number): UseInventoryAdjustmentSyncStatusReturn => {
  const [{ data, fetching }] = useQuery({
    query: GetProductInventoryAdjustmentsDocument,
    variables: { input: { productId, limit: 50 } },
  })

  const isSyncing = useMemo(() => {
    if (data?.inventoryAdjustment.listByProduct.__typename !== "InventoryAdjustmentListSuccess") return false
    return data.inventoryAdjustment.listByProduct.items.some(
      (item) => item.adjustmentType === InventoryAdjustmentType.As400Adjustment && !TERMINAL_STATUSES.has(item.status)
    )
  }, [data])

  return { isSyncing, isFetching: fetching }
}
